import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Commons from "../../../util/commons";
import Tippy from '@tippyjs/react';
import moment from "moment";

const AllFieldsRequestPaymentRenderer = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const [borderClass, setBorderClass] = useState("sales-grid-row");

    useImperativeHandle(ref, () => ({
        refresh(params) { return true; }
    }));

    useEffect(() => {
        if (props.node.data != null) {
            var addcls = props.node.data
                ? props.node.data.cancellationMark
                    ? "row-canceled-status"
                    : props.node.data.mark
                        ? "row-sended-status"
                        : "row-not-sended-status"
                : "";
            setBorderClass("sales-grid-row " + addcls);
        }
    }, [props.node])

    const rowData = <div className="container sales-aggrid-tooltip-inner">
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight"><b>{t("TimeStamp")}:</b></div>
            <div className="p-1 bd-highlight"><span>{props.data ? props.data.timestamp : ""}</span></div>
        </div>
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight"><b>{t("TransactionId")}:</b></div>
            <div className="p-1 bd-highlight"><span>{props.data ? props.data.posTransaction.transactionId : ""}</span></div>
        </div>
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight"><b>{t("Result")}:</b></div>
            <div className="p-1 bd-highlight"><span>{props.data ? props.data.posTransaction.result : ""}</span></div>
        </div>
        <div className="d-flex bd-highlight">
            <div className="p-1 flex-grow-1 bd-highlight"><b>{t("Status")}:</b></div>
            <div className="p-1 bd-highlight"><span>{props.data ? props.data.posTransaction.status : ""}</span></div>
        </div>
    </div>;

    return (
        <div className={borderClass}>
            <div className="d-flex bd-highlight allFieldsColumnRow">
                <div className="p-0 bd-highlight">
                    <span>
                        <Tippy trigger="click" content={rowData}>
                            <i className="fa fa-info-circle" style={{ marginRight: 6 }}></i>
                        </Tippy>
                        <b>{props.data ? moment(props.data.timestamp).format('DD/MM/YYYY HH:mm') + " " : ""}</b>
                    </span>
                    <span>{props.data ? props.data.posTransaction.result : ""}</span>
                </div>
            </div>
            <div className="d-flex bd-highlight allFieldsColumnRow">
                <div className="p-0 bd-highlight">
                    <span style={{ fontStyle: "italic" }}>{props.data ? props.data.signature : ""}</span>
                </div>
            </div>
            <div className="d-flex bd-highlight allFieldsColumnRow">
                <div className="p-0 flex-grow-1 bd-highlight">
                    <span>{props.data ? props.data.posTransaction.transactionId : ""}</span>
                </div>
                <div className="p-0 bd-highlight">
                    <span>
                        {props.data
                            ? props.data.saleInstance?.cancellationMark
                                ? <span className="tooltip-canceled-status">{props.data.saleInstance.cancellationMark}</span>
                                : props.data.saleInstance?.mark
                                    ? <span className="tooltip-sended-status">{props.data.saleInstance.mark}</span>
                                    : <span className="tooltip-not-sended-status">{t("notInMyData")}</span>
                            : ""}
                    </span>
                </div>
            </div>
            <div className="d-flex bd-highlight allFieldsColumnRow">
                <div className="p-0 bd-highlight">
                    <span>{t("TotalPaymentMin")}: </span>
                    <span><b>{props.data ? Commons.formatNumber(props.data.amount.toFixed(2)) : 0.00}</b></span>
                </div>
            </div>
        </div>
    );
});

export default AllFieldsRequestPaymentRenderer;
